// TODO: unify objs of STATUSES with STATUSES_BADGES
import { SORT_LABELS, SORT_VALUES } from './sort';

const OFFER = {
  ACTIONS: {
    LIKE: 'like',
    REMOVE: 'remove',
  },
  APPROVED_OFFER: 'Oferta aprovada',
  COUNT_FORMAT: {
    NO_OFFERS: '0 ofertas',
    ONE_OFFER: '1 oferta',
    OFFERS: 'ofertas',
  },
  BADGES: {
    FEATURED: 'DESTAQUE',
    LOWEST_PRICE: 'MENOR PREÇO',
    LOWEST_PRICE_NOW: 'MENOR PREÇO AGORA',
    FINISHED_OFFER: 'OFERTA ENCERRADA',
    FINISHED: 'ENCERRADA',
    VERIFIED: 'OFERTA VERIFICADA',
  },
  BREADCRUMB_FIRST_ITEM: 'Ofertas',
  DOMAIN: 'offer',
  EDIT_MODAL: {
    EDIT_COUPON_LABEL: 'Adicionar cupom',
    EDIT_INSTRUCTIONS_LABEL: 'Alterar informações adicionais ou comentários',
    EDIT_PRICE_LABEL: 'Editar preço',
    SAVE_BUTTON: 'Salvar edição',
    SUBTITLE:
      'Preencha os campos abaixo para solicitar a edição do conteúdo publicado',
    TITLE: 'Editar conteúdo',
  },
  FILTER_ACTION_TYPES: {
    PRICE_RANGE: 'PRICE_RANGE',
    REMOVE_PRICE_RANGE: 'REMOVE_PRICE_RANGE',
    REMOVE_STORE: 'REMOVE_STORE',
    REMOVE_VENUE: 'REMOVE_VENUE',
    RESET: 'RESET',
    STORES: 'STORES',
    VENUE: 'VENUE',
  },
  KNOW_MORE: 'Saiba mais!',
  LAST_OFFERS_HASH: 'last-offers',
  LOAD_MORE_OFFERS: 'Exibir mais ofertas',
  MY_OFFERS_PAGINATION_LIMIT: 10,
  NO_OFFERS_YET: 'Ainda não há ofertas.',
  PRICE_TYPES: {
    COUPON: 'COUPON',
    FREE: 'FREE',
    NORMAL: 'NORMAL',
    STARTING_AT: 'STARTING_AT',
  },
  REVIEWS: { DEFAULT_RATING_VALUE: 5 },
  SEE_OFFER: 'Ver Oferta',
  SIDEBAR_FEATURED_OFFERS_LIMIT: 4,
  SORT_LABELS,
  SORT_VALUES,
  STATUSES: {
    APPROVED: 'APPROVED',
    ARCHIVED: 'ARCHIVED',
    BLOCKED: 'BLOCKED',
    DUPLICATED: 'DUPLICATED',
    ETERNAL: 'ETERNAL',
    FINISHED: 'FINISHED',
    HIDDEN: 'HIDDEN',
    PRE_APPROVED: 'PRE_APPROVED',
    RESTRICTED: 'RESTRICTED',
    ROLLBACK: 'ROLLBACK',
    SCHEDULED: 'SCHEDULED',
    TOP_OFFER: 'TOP_OFFER',
    WAITING: 'WAITING',
  },
  STATUSES_BADGES: {
    APPROVED: {
      NAME: 'Ativa',
      BADGE_TYPE: 'default',
    },
    ARCHIVED: {
      NAME: 'Arquivada',
      BADGE_TYPE: 'default',
    },
    BLOCKED: {
      NAME: 'Bloqueada',
      BADGE_TYPE: 'error',
    },
    DUPLICATED: {
      NAME: 'Duplicada',
      BADGE_TYPE: 'error',
    },
    ETERNAL: {
      NAME: 'Eterna',
      BADGE_TYPE: 'spotlight',
    },
    FINISHED: {
      NAME: 'Encerrada',
      BADGE_TYPE: 'default',
    },
    HIDDEN: {
      NAME: 'Oculta',
      BADGE_TYPE: 'default',
    },
    PRE_APPROVED: {
      NAME: 'Pré aprovada',
      BADGE_TYPE: 'default',
    },
    RESTRICTED: {
      NAME: 'Restrita',
      BADGE_TYPE: 'default',
    },
    ROLLBACK: {
      NAME: 'Rollback',
      BADGE_TYPE: 'error',
    },
    SCHEDULED: {
      NAME: 'Agendada',
      BADGE_TYPE: 'spotlight',
    },
    TOP_OFFER: {
      NAME: 'Menor preço',
      BADGE_TYPE: 'spotlight',
    },
    WAITING: {
      NAME: 'Aguardando aprovação',
      BADGE_TYPE: 'default',
    },
  },
  VENUES_VALUES: { INTERNATIONAL: 'international', NATIONAL: 'national' },
  VIEW_MODES: { GRID: 'GRID', LIST: 'LIST' },
  WAITING_APPROVAL_OFFER: 'Oferta aguardando aprovação.',
};

export default OFFER;
